module.exports = __webpack_public_path__ + "dcd48605fa9d705300fdadb42e8ab245.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room3/audio2/03_2MCA-Das-Zimmer.ogg
// module id = 775
// module chunks = 0